import { apiSlice } from '../apiSlice';
import {
	ClickPageDTO,
	ClockPageFilter,
	ClockRequest,
} from '../DTO/app-setting/clock.interface';
import {
	NoticePageDTO,
	NoticePageFilter,
	NoticeRequest,
} from '../DTO/app-setting/notice.interface';
import { SuccessResponse, Paginated } from '../DTO/common.interface';

export const noticeApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getNoticeList: builder.query<
			SuccessResponse<Paginated<NoticePageDTO>>,
			NoticePageFilter
		>({
			query: (body) => ({
				url: `/web/notification-template/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['NoticeList'],
		}),
		createNotice: builder.mutation<SuccessResponse<any>, NoticeRequest>({
			query: (body) => ({
				url: `/web/notification-template`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['NoticeList'],
		}),
		deleteNotice: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/notification-template/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['NoticeList'],
		}),
		updateNotice: builder.mutation<SuccessResponse<any>, NoticeRequest>({
			query: (body) => ({
				url: `/web/notification-template`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['NoticeList'],
		}),
	}),
});

export const {
	useGetNoticeListQuery,
	useCreateNoticeMutation,
	useDeleteNoticeMutation,
	useUpdateNoticeMutation,
} = noticeApiSlice;
